import { Surgery } from 'common/types'

export type TAddRepModalProps = {
  onClose: () => void
  isOpen: boolean
  type?: 'sales' | 'guest'
  surgeryId: Surgery['_id']
  assetsCompanies?: number[]
}

export enum TabValue {
  InviteRep,
  SignUpRep,
}

export type TabPanelProps = {
  $isHidden: Boolean
}
